import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { login, currentUser, forcePasswordChangeGet, forgotPasswordGet, changePasswordGet, rolePermissionApi, getVersionListGet, userOrganisationListGet, verifyMfaOtpPost, resendOtpGet, verifyOtpPost, mfaAssignPut, associateSoftwareTokenPut, verifySoftwareTokenPut, phoneLoginPost, otpVerifyPost } from '../Model/LoginModel';
// Store token in memory for session
let accessToken = '';

export const setAccessToken = (token) => {
    accessToken = token;
};

export const getAccessToken = () => {
    return accessToken;
}; 

export const loginGetApi = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}login`, data, null);
    return login(response);
};
export const getCurrentUser = async () => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}currentuser`);
    return currentUser(response);
};
export const rolePermissionGetApi = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}generic/roles_permissions`, data);
    return rolePermissionApi(response);
};

export const forcePasswordChange = async (data, headers) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}userforcepasswordchange`, data, headers);
    return forcePasswordChangeGet(response);
};
export const forgotPassword = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}forgotpassword`, data, null);
    return forgotPasswordGet(response);
};
export const changePassword = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}confirmforgotpassword`, data, null);
    return changePasswordGet(response);
};
export const getVersionList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}version`, data);
    return getVersionListGet(response);
};
export const userOrganisationGet = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/user_details`, data);
    return userOrganisationListGet(response);
};
export const verifyMfaOtp = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}mfa/verify`, data);
    return verifyMfaOtpPost(response);
};
export const resendOtp = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}resend_confirmation`, data);
    return resendOtpGet(response);
};
export const verifyOtp = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}confirm_signup`, data);
    return verifyOtpPost(response);
};
export const mfaAssign = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}usr_mfa_assign`, data);
    return mfaAssignPut(response);
};
export const associateSoftwareToken = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}associate_software_token`, data);
    return associateSoftwareTokenPut(response);
};
export const verifySoftwareToken = async (data) => {
    const response = await put(`${process.env.EXTENDED_URL_WITHOUT_VERSION}verify_software_token`, data);
    return verifySoftwareTokenPut(response);
};

// Phone OTP login functionality
export const phoneLogin = async (phoneNumber) => {
    const data = { username: phoneNumber };
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}login`, data);
    return phoneLoginPost(response);
};

export const otpVerify = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}otp/verify`, data);
    return otpVerifyPost(response);
};